import { Link } from 'react-router-dom'
import { Button } from 'app/components/ui/button'

export function AccountSetupErrorScreen({ error }: { error: string }) {
  return (
    <div className="grid h-dvh place-items-center overflow-y-auto bg-surface-subtle p-4">
      <div className="w-full max-w-md rounded-xl border border-default bg-surface p-8 text-center shadow-sm sm:p-12">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <span className="text-3xl">😕</span>
        </div>
        <h1 className="mb-3 text-2xl font-semibold text-strong">Something went wrong</h1>
        <p className="mb-4 text-base italic text-subtle">{error}</p>
        <p className="mb-8 text-sm text-subtle">Please contact your administrator to request a new invite.</p>
        <Button variant="tertiary" asChild>
          <Link to="/login" className="inline-flex items-center font-semibold">
            Return to login
          </Link>
        </Button>
      </div>
    </div>
  )
}
